import React, { useEffect, useState } from 'react';
import { Dialog, ListItem, List, Toolbar, Slide, Grid, DialogTitle } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { useIntl } from 'react-intl';
import { ButtonSubmit, Regex, SelectDropDown } from '../../../../Components';
import { useStyles } from './Existinguser.style';
import { LanguageProps, TextField2 } from '../../../../Components/Field';
import { useDispatch, useSelector } from 'react-redux';
import { useApiValidationSnackbar } from '../../../../Components/Snackbar/SnackbarAlert';
import { useSnackbar } from 'notistack';
import CustomerSevicesApi from '../../../../Redux/Actions/CustomerAction';
import UserSevicesApi from '../../../../Redux/Actions/UserAction'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>
) {
    return (
        <Slide direction="up" ref={ref} {...props} />
    );
});
interface createGrpupProps {
    openpopup: any;
    onclose: any;
}

export const ExistingUser = ({ openpopup, onclose }: createGrpupProps) => {
    const { currentUser, apiToken, userList, sendInvite,getCustomersById} = useSelector((state: any) => ({
        currentUser: state?.UserReducer?.currentUser,
        apiToken: state?.UserReducer?.apiToken,
        userList: state?.UserReducer?.userList,
        sendInvite: state?.CustomerReducer?.sendInvite,
        getCustomersById: state?.CustomerReducer?.getCustomersById
    }))
    const [input, setInput] = useState({ firstName: '', lastName: '', email: '', language: '' });
    const [selectUser,setSelectUser]=React.useState('')
    const navigate = useNavigate();
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const dispatch: any = useDispatch();
    const { ErrorMessage } = useApiValidationSnackbar();
    const { enqueueSnackbar } = useSnackbar();
    const customerIdParam = useLocation()?.pathname?.slice(28);
    const submit = () => {
        const Error: any = "fill";
        if (!input?.email || !input?.firstName || !input?.lastName || !input?.language) {
            ErrorMessage(sendInvite, Error);
        }else if(!Regex.test(input?.email.toString())){
            enqueueSnackbar(formatMessage({id:'form.emailWrongFormat'}),{
              variant: 'error'
            })
        } else {
            const param = {
                email: input?.email,
                firstName: input?.firstName,
                lastName: input?.lastName,
                language: LanguageProps[input?.language],
                roleId: 1,    //inviting client admin
                sentBy: currentUser?.customerId,
                customerId: customerIdParam
            }
             dispatch(CustomerSevicesApi.sendClientAdminInvitation(param, apiToken, enqueueSnackbar));
            if (sendInvite) {
                setTimeout(() => {
                dispatch(CustomerSevicesApi.getCustomerById(customerIdParam,apiToken))
                onclose()
                }, 1000);
               
            }
        }
    }
    const makeAdminRole=()=>{
           const newData = getCustomersById?.users?.filter((item)=>item?.id==selectUser);
           if(newData?.length){
               const userData ={
                email:newData[0]?.email,
                firstName:newData[0]?.firstName,
                lastName:newData[0]?.lastName,
                role:"ClientAdmin"
                }
                dispatch(UserSevicesApi.userUpdate(selectUser,userData, apiToken,enqueueSnackbar));
                setTimeout(() => {
                    dispatch(CustomerSevicesApi.getCustomerById(customerIdParam,apiToken));
                    onclose()
                },1000);
           }
    }
    return (
        <div>
            <Dialog open={openpopup == "New Invite"} TransitionComponent={Transition}>
                <DialogTitle id="alert-dialog-title">{formatMessage({ id: "group.user.newUserInvite", defaultMessage: "New User Invite" })}</DialogTitle>
                <List>
                    <ListItem>
                        <Grid>
                            <Grid container spacing={3} className={classes.marginTop10}>
                                <Grid item xs={4}>
                                    <TextField2 onChange={(str: string) => setInput({ ...input, firstName: str })}
                                        placeholder={formatMessage({ id: "form.fillInFirstName", defaultMessage: " Enter first name" })}
                                        value={input?.firstName} Textlabel="customer.create.firstName" />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField2 onChange={(str: string) => setInput({ ...input, lastName: str })}
                                        placeholder={formatMessage({ id: "form.fillInLastName", defaultMessage: " Enter last name" })}
                                        value={input?.lastName} Textlabel="customer.create.lastName" />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField2 onChange={(str: string) => setInput({ ...input, email: str })}
                                        placeholder={formatMessage({ id: "form.fillInEmail", defaultMessage: " Enter email" })}
                                        value={input?.email} Textlabel="customer.create.email" />
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <SelectDropDown placeholder={formatMessage({ id: "customer.create.selectLanguage", defaultMessage: "Select Language" })}
                                    handleChange={(event) => setInput({ ...input, language: event?.target?.value })} fieldName={'lang'} OptionsValue={["Svenska", "English"]}
                                    selected={input?.language}
                                    Textlabel="selectLanguage" />
                            </Grid>
                        </Grid>
                    </ListItem>
                </List>
                <Toolbar>
                    <ButtonSubmit text={'model.title.cancel'} className={classes.padding5} onClick={() => onclose()} />
                    <Grid container justifyContent={'flex-end'}>
                        <ButtonSubmit text={'component.mtable.save'} onClick={() => submit()} />
                    </Grid>
                </Toolbar>
            </Dialog>
            <Dialog open={openpopup == "Existing User"} TransitionComponent={Transition}>
                <DialogTitle id="alert-dialog-title" style={{ width: 320 }}>{formatMessage({ id: "group.user.makeadmin", defaultMessage: "Make Admin" })}</DialogTitle>
                <List>
                    <ListItem>
                        <Grid>
                            <Grid item xs={12}>
                                <SelectDropDown nameid ="firstname"placeholder={getCustomersById?.users?.length == 0?"No data":formatMessage({ id: "document.upload.selectUser", defaultMessage: "Select User" })}
                                    handleChange={(event) =>setSelectUser(event?.target?.value)} fieldName={'lang'} selctOption={getCustomersById?.users}
                                    selected={selectUser} />
                            </Grid>
                        </Grid>
                    </ListItem>
                </List>
                <Toolbar>
                    <ButtonSubmit text={'model.title.cancel'} onClick={() => onclose()} />
                    <Grid container justifyContent={'flex-end'}>
                        <ButtonSubmit text={'model.title.save'}  onClick={makeAdminRole}/>
                    </Grid>
                </Toolbar>
            </Dialog>
        </div>
    )
}